module.exports = __webpack_public_path__ + "img/card2.d725ea48.png";